'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var classNames = require('classnames');
var makeStyles = require('../../Styles/makeStyles.js');
var Drawer = require('../Drawers/Drawer.js');
var DrawerHeader = require('../Drawers/DrawerHeader.js');
var Paper = require('../../Surfaces/Paper/Paper.js');
var GlobalRightRailStyles = require('./GlobalRightRailStyles.js');
var createRightRailCssTransition = require('./createRightRailCssTransition.js');
var constants = require('./constants.js');
var Toolbar = require('../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');
var Slide = require('../../../node_modules/@material-ui/core/esm/Slide/Slide.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var rightRailTransition = createRightRailCssTransition.createRightRailCssTransition('width');
var rightRailStyles = {
  width: "var( ".concat(constants.RightRailCssVars.rightRailWidth, " )"),
  transition: rightRailTransition,
  overflowX: 'hidden'
};
var useStyles = makeStyles["default"](function (theme) {
  return {
    layer: {
      display: 'flex'
    },
    content: {
      flexGrow: 1
    },
    root: function root(_ref) {
      var _objectSpread3;

      var isOpened = _ref.isOpened;
      return _objectSpread({}, rightRailStyles, (_objectSpread3 = {
        width: constants.RIGHT_RAIL_CLOSED_WIDTH,
        flexShrink: 0
      }, defineProperty(_objectSpread3, theme.breakpoints.up('md'), {
        width: rightRailStyles.width,
        maxWidth: "var( ".concat(constants.RightRailCssVars.rightRailWidth, " ) !important")
      }), defineProperty(_objectSpread3, '& .MuiDrawer-paper', _objectSpread({}, rightRailStyles, defineProperty({
        zIndex: theme.zIndex.appBar - 1,
        width: isOpened ? '100vw' : rightRailStyles.width
      }, theme.breakpoints.up('md'), {
        width: rightRailStyles.width,
        maxWidth: "var( ".concat(constants.RightRailCssVars.rightRailWidth, " ) !important")
      }))), _objectSpread3));
    },
    drawerContent: {
      display: 'flex',
      zIndex: theme.zIndex.appBar - 1,
      overflow: 'hidden'
    },
    paper: function paper(_ref2) {
      var isOpened = _ref2.isOpened;
      return defineProperty({
        zIndex: theme.zIndex.appBar - 1,
        width: isOpened ? '100vw' : rightRailStyles.width
      }, theme.breakpoints.up('md'), {
        width: rightRailStyles.width
      });
    },
    belowMainNav: {
      zIndex: theme.zIndex.appBar - 1
    },
    iconContent: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: 'content',
      height: '100vh',
      paddingTop: theme.spacing(1)
    },
    slideContainer: {
      flex: 1
    },
    railContentContainer: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '100%',
      minHeight: '100%'
    },
    railContent: {
      padding: theme.spacing(0, 3),
      overflow: 'hidden auto',
      flexGrow: 1
    }
  };
});

function RightRail(_ref4) {
  var open = _ref4.open,
      _ref4$appearsBelowMai = _ref4.appearsBelowMainNav,
      appearsBelowMainNav = _ref4$appearsBelowMai === void 0 ? false : _ref4$appearsBelowMai,
      iconContent = _ref4.iconContent,
      headerContent = _ref4.headerContent,
      railContent = _ref4.railContent,
      pageContent = _ref4.children,
      upstreamClasses = _ref4.classes;
  var classes = useStyles({
    classes: upstreamClasses,
    isOpened: open
  });
  return React__default["default"].createElement(React__default["default"].Fragment, null, React__default["default"].createElement(GlobalRightRailStyles, {
    isOpened: open
  }), React__default["default"].createElement("div", {
    className: classes.layer
  }, React__default["default"].createElement("main", {
    className: classes.content
  }, pageContent), React__default["default"].createElement(Drawer, {
    classes: {
      root: classes.root,
      paper: classNames__default["default"](classes.paper, defineProperty({}, classes.belowMainNav, appearsBelowMainNav))
    },
    anchor: "right",
    variant: "permanent",
    open: open
  }, appearsBelowMainNav && React__default["default"].createElement(Toolbar["default"], null), React__default["default"].createElement("div", {
    className: classes.drawerContent
  }, React__default["default"].createElement(Paper, {
    square: true
  }, React__default["default"].createElement("div", {
    className: classes.iconContent
  }, iconContent)), React__default["default"].createElement("div", {
    className: classes.slideContainer
  }, React__default["default"].createElement(Slide["default"], {
    direction: "left",
    "in": open
  }, React__default["default"].createElement("div", {
    className: classes.railContentContainer
  }, React__default["default"].createElement(DrawerHeader, null, headerContent), React__default["default"].createElement("div", {
    className: classes.railContent
  }, railContent))))))));
}

module.exports = RightRail;
